export default "__VITE_ASSET__Dl5wXvJ8__"